var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"outs"},[_c('div',{staticClass:"content1"},[_c('itemContent',{attrs:{"data-list":_vm.dataList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }